<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '../cn'

  export interface IconErrorProps {
    class?: HTMLAttributes['class']
  }

  const props = withDefaults(defineProps<IconErrorProps>(), {
    class: undefined
  })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    :class="cn('text-error size-5', props.class)"
  >
    <path
      fill-rule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
